<template>
  <RequestStatusPicker
    :value="value"
    :placeholder="placeholder"
    @input="$emit('input', $event)"
  />
</template>

<script>
import RequestStatusPicker from '@/components/pickers/RequestStatusPicker'

export default {
  name: 'OvertimeStatusPicker',

  components: {
    RequestStatusPicker,
  },

  props: {
    value: {
      type: Array,
      default: () => [],
    },

    placeholder: {
      type: String,
      default: 'Select Overtime status',
    },
  },
}
</script>
